import { useEffect } from "react";
import "lenis/dist/lenis.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteLayout } from "@/components/site/SiteLayout";
import { LANGS, ROUTES } from "@/lib/i18n";
import Home from "@/pages/Home";
import Audience from "@/pages/Audience";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Business from "@/pages/Business";
import Contact from "@/pages/Contact";
import Apply from "@/pages/Apply";
import { ThankYou, Legal, NotFound } from "@/pages/Misc";
import AdminLogin, { AuthCallback } from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const PAGES = {
  home: <Home />, moving: <Audience kind="moving" />, living: <Audience kind="living" />, about: <About />,
  services: <Services />, business: <Business />, contact: <Contact />, apply: <Apply />,
  thanks: <ThankYou />, privacy: <Legal kind="privacy" />, cookies: <Legal kind="cookies" />,
};

const SmoothScroll = () => {
  const { pathname } = useLocation();
  const admin = pathname.startsWith("/admin");
  useEffect(() => {
    if (admin || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let id = requestAnimationFrame(function raf(t) { lenis.raf(t); id = requestAnimationFrame(raf); });
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = undefined; };
  }, [admin]);
  return null;
};

const RootRedirect = () => <Navigate to={localStorage.getItem("his_lang") === "sl" ? "/sl" : "/tr"} replace />;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      {LANGS.flatMap((lang) =>
        Object.entries(ROUTES[lang]).map(([key, slug]) => (
          <Route key={`${lang}-${key}`} path={`/${lang}${slug}`} element={<SiteLayout lang={lang} page={key}>{PAGES[key]}</SiteLayout>} />
        ))
      )}
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/applications" element={<AdminDashboard />} />
      <Route path="/sl/*" element={<SiteLayout lang="sl" page="notfound"><NotFound /></SiteLayout>} />
      <Route path="*" element={<SiteLayout lang="tr" page="notfound"><NotFound /></SiteLayout>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <AppRouter />
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}
